import {
  DocumentReference,
  ISODateType,
  ISoftDelete,
  Timestamp,
} from '@principle-theorem/shared';
import { IPractice } from './practice';
import { IStaffer } from '../staffer/staffer';

export enum PracticeSetupWizardStatus {
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  Complete = 'complete',
}

export enum PracticeSetupWizardCollection {
  Steps = 'setupWizardSteps',
  Interactions = 'setupWizardInteractions',
  PendingAssignmentNotifications = 'pendingAssignmentNotifications',
}

export const PRACTICE_SETUP_WIZARD_STATUS_COLOUR_MAP: {
  [key in PracticeSetupWizardStatus]: string;
} = {
  [PracticeSetupWizardStatus.NotStarted]: 'default',
  [PracticeSetupWizardStatus.InProgress]: 'primary',
  [PracticeSetupWizardStatus.Complete]: 'success',
};

export interface IPracticeSetupWizard extends ISoftDelete {
  practiceRef: DocumentReference<IPractice>;
  status: PracticeSetupWizardStatus;
  clickUpTaskId?: string;
  completedAt?: Timestamp;
  dismissedAt?: Timestamp;
  assignedStaff?: DocumentReference<IStaffer>[];
  targetLaunchDate?: ISODateType;

  /**
   * Map of stafferId → most recent engagement timestamp.
   * */
  lastEngagementByStaffer?: Record<string, Timestamp>;

  /**
   * Map of stafferId → when the "Disengaged" ClickUp comment was posted.
   * Cleared when staffer returns to Active.
   */
  disengagementNotifiedAt?: Record<string, Timestamp>;

  /**
   * Map of stafferId → when this staffer was added to assignedStaff.
   */
  assignedStaffAt?: Record<string, Timestamp>;

  /**
   * Map of stafferId → last time daily-check email was sent to this staffer.
   * Per-staffer idempotency (23h window).
   */
  lastDailyCheckSentAt?: Record<string, Timestamp>;

  /**
   * Map of stafferId → last time weekly digest was sent to this staffer.
   * Per-staffer idempotency (6-day window).
   * */
  lastWeeklyDigestSentAt?: Record<string, Timestamp>;
}

export interface IPendingAssignmentStep {
  stepId: string;
  stepTitle: string;
  dueDate?: Timestamp;
}

export interface IPendingAssignmentNotification {
  wizardRefPath: string;
  assigneeRefPath: string;
  assigneeName: string;
  steps: IPendingAssignmentStep[];
  taskName?: string;
}
